var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['cart-footer', _vm.extraclass]},[_c('p',{staticClass:"header"},[_vm._v("\n    "+_vm._s(_vm.header)+"\n  ")]),_vm._v(" "),_c('p',{staticClass:"amount"},[_vm._v("\n    "+_vm._s(_vm.amount)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }